import React from 'react';
import { FiHome, FiUsers, FiBook, FiDollarSign, FiSettings, FiShield } from 'react-icons/fi';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { DashboardContainer, DashboardHeader, StatsGrid, StatCard, StatIcon, StatInfo, SectionTitle } from './Dashboard.styles';

const AdminDashboard = () => {
  const menuItems = [
    { icon: <FiHome />, label: 'Dashboard', path: '/admin' },
    { icon: <FiUsers />, label: 'Users Management', path: '/admin/users' },
    { icon: <FiBook />, label: 'Course Management', path: '/admin/courses' },
    { icon: <FiDollarSign />, label: 'Payments', path: '/admin/payments' },
    { icon: <FiShield />, label: 'Moderation', path: '/admin/moderation' },
    { icon: <FiSettings />, label: 'Settings', path: '/admin/settings' },
  ];

  return (
    <DashboardLayout menuItems={menuItems}>
      <DashboardContainer>
        <DashboardHeader>
          <div>
            <h1>System Admin Dashboard 🛡️</h1>
            <p>Manage platform operations and users</p>
          </div>
        </DashboardHeader>

        <StatsGrid>
          <StatCard>
            <StatIcon color="#2c5f34">
              <FiUsers />
            </StatIcon>
            <StatInfo>
              <h3>5,432</h3>
              <p>Total Users</p>
            </StatInfo>
          </StatCard>

          <StatCard>
            <StatIcon color="#10B981">
              <FiBook />
            </StatIcon>
            <StatInfo>
              <h3>234</h3>
              <p>Total Courses</p>
            </StatInfo>
          </StatCard>

          <StatCard>
            <StatIcon color="#F59E0B">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="9" cy="7" r="4" strokeWidth="2"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </StatIcon>
            <StatInfo>
              <h3>89</h3>
              <p>Active Teachers</p>
            </StatInfo>
          </StatCard>

          <StatCard>
            <StatIcon color="#EF4444">
              <FiDollarSign />
            </StatIcon>
            <StatInfo>
              <h3>KES 2.4M</h3>
              <p>Monthly Revenue</p>
            </StatInfo>
          </StatCard>
        </StatsGrid>

        <SectionTitle>System Overview</SectionTitle>
        <div style={{ 
          padding: '40px', 
          background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
          borderRadius: '16px',
          color: 'white',
          textAlign: 'center'
        }}>
          <h3>System administration tools will be displayed here</h3>
          <p>User management, content moderation, analytics, and system configuration</p>
        </div>
      </DashboardContainer>
    </DashboardLayout>
  );
};

export default AdminDashboard;

